module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3e3698d8783d6f7d5350e53b9ad370b3.png";